// React
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

// Containers Injections
import { SuppliersInjection } from '../../containers/suppliersInjection';

// View
import { SuppliersPage } from './view';

export const Suppliers = () => {
  const [activeStatus, setActiveStatus] = useState('true');
  const [modal_animationLeft, setmodal_animationLeft] = useState(false);

  const history = useHistory();

  const { getSuppliers, success, suppliesList, deleteSuppliers } =
    SuppliersInjection();

  function tog_animationLeft() {
    setmodal_animationLeft(!modal_animationLeft);
  }

  const handleDelete = (id) => {
    deleteSuppliers(id);
  };

  const handleEdit = (values) => {
    const { id } = values;
    setmodal_animationLeft(true);

    history.push(`/fornecedores/edit/${id}`);
  };

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Nome</span>,
      sortable: true,

      id: 'name',
      cell: (cell) => {
        return (
          <React.Fragment>
            <div className="d-flex align-items-center fw-medium ">
              <Link
                className="currency_name"
                to={`/fornecedores/edit/${cell.id}`}
              >
                {cell.name}
              </Link>
            </div>
          </React.Fragment>
        );
      },
      selector: (cell) => cell.name && cell.name.toUpperCase(),
    },
    {
      name: <span className="font-weight-bold fs-13">CPF/CNPJ</span>,
      sortable: true,
      id: 'cpf',
      selector: (cell) => (cell.cnpj_cpf ? cell.cnpj_cpf : '-'),
    },
    {
      name: <span className="font-weight-bold fs-13">Cidade</span>,
      sortable: true,
      id: 'city',
      selector: (cell) => cell.city && cell.city.toUpperCase(),
    },
    {
      name: <span className="font-weight-bold fs-13">Telefone</span>,
      sortable: true,
      id: 'phone1',
      selector: (cell) => cell.phone1 && cell.phone1,
    },
  ];

  useEffect(() => {
    getSuppliers(activeStatus);
  }, [success, activeStatus]);

  return (
    <SuppliersPage
      history={history}
      columns={columns}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
      suppliesList={suppliesList || []}
      setActiveStatus={setActiveStatus}
      tog_animationLeft={tog_animationLeft}
    />
  );
};
